import {
  FIRECMS_LOCALE_STORAGE_KEY,
} from "@firecms/core";
import {
  LOCALE_ORDER,
  type Locale,
} from "../localization/constants";
import { baseLocaleCode } from "../localization/getStoredFireCMSLocale";

/** Locales exposed in the admin UI language selector (aligned with product content locales). */
export const ADMIN_FIRECMS_LOCALES = LOCALE_ORDER satisfies readonly Locale[];

const ALLOWED = new Set<string>(ADMIN_FIRECMS_LOCALES);

export function isAllowedFireCMSLocale(code: string): boolean {
  return ALLOWED.has(baseLocaleCode(code));
}

/** Normalize stored/user locale to one of the four allowed codes, defaulting to English. */
export function normalizeFireCMSLocale(code: string | undefined): Locale {
  if (code && isAllowedFireCMSLocale(code)) {
    return baseLocaleCode(code) as Locale;
  }
  return "en";
}

/** Drop unsupported locales (e.g. de, it, hi) from FireCMS localStorage. */
export function sanitizeStoredFireCMSLocale(): Locale {
  if (typeof window === "undefined") {
    return "en";
  }
  const stored = localStorage.getItem(FIRECMS_LOCALE_STORAGE_KEY)?.trim();
  const normalized = normalizeFireCMSLocale(stored);
  if (stored !== normalized) {
    localStorage.setItem(FIRECMS_LOCALE_STORAGE_KEY, normalized);
  }
  return normalized;
}
